class Delivery {

	constructor(elem) {
		this.delivery = elem;
    this.ww = $(window).width();
    this.form = this.delivery.find('[data-delivery-search-form]');
	}

	initialize() {
    let index = 0;
    let parent = this.delivery;
    let tabs = parent.find('[data-tabs]');
    let that = this;

    $('[data-delivery-link], [data-delivery-back]').on('click', function(e) {
      let map = parent.find('[data-delivery-map]');

      map.toggleClass('show');

      e.preventDefault();
    });

    $('[data-delivery-link]').on('click', function(e) {
      let attr = $(this).attr('data-delivery-link');

      if (attr == 'shops') {
        that.resize();

        if (that.ww < 481) {
          $('html, body').animate({scrollTop: `0px`}, 500);
        }
      }

      e.preventDefault();
    });

    tabs.find('[data-tabs-head]').children().on('click', function(e) {
      let el = $(this);

      if (!el.is('[data-delivery-link]')) {
        index = el.index();
      }
    });

    $('[data-delivery-back]').on('click', function(e) {
      tabs.find('[data-tabs-head]').children().removeClass('active')
      tabs.find('[data-tabs-head]').children().eq(index).addClass('active');

      tabs.find('[data-tabs-body]').children().removeClass('active');
      tabs.find('[data-tabs-body]').children().eq(index).addClass('active');
    });

    $('[data-delivery-list]').children().each(function() {
      let el = $(this);
      let scheduleEl = el.find('[data-delivery-schedule]');
      let schedule = scheduleEl.text().split(' – ');
      let status = el.parent().find('[data-delivery-status]');

      let time = new Date();
      let timeStart = new Date();
      timeStart.setHours(schedule[0].split(':')[0], schedule[0].split(':')[1], 0);
      let timeEnd = new Date();
      timeEnd.setHours(schedule[1].split(':')[0], schedule[1].split(':')[1], 0);

      if(time >= timeStart && time <= timeEnd ){
        status.removeClass('status-close');
        status.text('Открыто')
      } else {
        status.addClass('status-close');
        status.text('Закрыто')
      }
    });

    // this.form.on('click', function(e) {
    //   e.preventDefault();
    // });
	}

  resize() {
    this.ww = $(window).width();
  }
}

export {Delivery};

$(window).on('load', () => {
	let delivery = [];

	if ($('[data-delivery]').length > 0) {
		$('[data-delivery]').each(function(i) {
			delivery[i] = new Delivery($(this));
			delivery[i].initialize();
		});
	}
});
